var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"mx-auto",staticStyle:{"background-color":"#ffffff"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" - Provided by Digitech - GEMS")])])}
var staticRenderFns = []

export { render, staticRenderFns }